import PostCard from './PostCard'
import type { BlogPost } from '../../lib/blog/types'

export default function RelatedPosts({ posts }: { posts: BlogPost[] }) {
  if (!posts.length) return null
  return (
    <section className="mt-14">
      <h2 className="text-xl font-bold text-ink mb-5">Related reading</h2>
      <div className="grid gap-5 md:grid-cols-3">
        {posts.map((p) => (
          <PostCard key={p.slug} post={p} />
        ))}
      </div>
    </section>
  )
}
